import { z } from "zod";

// Contact form submission schema
export const contactFormSchema = z.object({
  name: z.string().min(1, "El nombre es requerido"),
  email: z.string().email("Email inválido"),
  message: z.string().min(10, "El mensaje debe tener al menos 10 caracteres"),
});

// Service interface
export const Service = {
  id: "string",
  title: "string",
  description: "string",
  icon: "string",
  details: "?string",
};

// Testimonial interface
export const Testimonial = {
  id: "string",
  company: "string",
  text: "string",
  author: "string",
};